import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  progressBarTop: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '19.5px',

    '@media screen and (min-width: 1441px)': {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },

  progressBarInfo: {
    fontWeight: 500,
    color: 'var(--text-primary)',
  },

  progressBarLabel: {
    color: 'var(--text-secondary)',
  },

  eventProgress: {
    '&, & .progressBar': {
      width: '100%',
    },

    '& .progressBar': {
      borderRadius: '2px',
      backgroundColor: 'var(--background-paper)',
      height: '10px',
      border: `1px solid var(--clr-frenchPass)`,

      '& .percentage': {
        display: 'none',
      },
    },
  },

  progressLow: {
    '& .fill': {
      backgroundColor: `var(--progress-low)!important`,
    },
  },

  progressMiddle: {
    '& .fill': {
      backgroundColor: `var(--progress-middle)!important`,
    },
  },

  progressFull: {
    '& .fill': {
      backgroundColor: `var(--progress-full)!important`,
    },
  },
}));

export default useStyles;
